import React, { useState, useMemo } from 'react';

import { useSegmentation } from '@printdeal/segmentation/react';
import { useLocation } from '@gatsbyjs/reach-router';
import { HeaderContext } from './context';

import {
  getAudiences,
  getQueryParamFromLocation,
} from '../../../templates/homepage/homepage-helper';

type HeaderContextProviderProps = {
  children: React.ReactNode;
};

const HeaderContextProvider = ({
  children,
}: HeaderContextProviderProps) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isAllCategoriesNavigationOpen, setIsAllCategoriesNavigationOpen] = useState(false);
  const [isFeaturedNavigationOpen, setIsFeaturedNavigationOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isClearSearch, setIsClearSearch] = useState(false);

  const location = useLocation();
  const { traits, isSuccess: isAudienceLoadedFromSegment } = useSegmentation();
  const audienceOverRideForPlayground = getQueryParamFromLocation(location, 'variant');

  const audiencesDataFromSegment = useMemo(
    () => getAudiences(traits, isAudienceLoadedFromSegment, audienceOverRideForPlayground),
    [traits, isAudienceLoadedFromSegment, audienceOverRideForPlayground],
  );

  const context = useMemo(() => ({
    isSticky,
    setIsSticky,
    isAllCategoriesNavigationOpen,
    setIsAllCategoriesNavigationOpen,
    isFeaturedNavigationOpen,
    setIsFeaturedNavigationOpen,
    isSearchOpen,
    setIsSearchOpen,
    isClearSearch,
    setIsClearSearch,
    isAudienceLoadedFromSegment,
    audiencesDataFromSegment,
    audienceOverRideForPlayground,
  }), [
    isSticky,
    isAllCategoriesNavigationOpen,
    isFeaturedNavigationOpen,
    isSearchOpen,
    isClearSearch,
    isAudienceLoadedFromSegment,
    audiencesDataFromSegment,
    audienceOverRideForPlayground,
  ]);

  return (
    <HeaderContext.Provider value={context}>
      {children}
    </HeaderContext.Provider>
  );
};

export default HeaderContextProvider;
